<template>
  <div class="home">
    <div class="logo">
      <img src="../assets/logo.png" alt="" />
    </div>
    <div class="content">
      <div class="banner">
        <img src="../assets/localbanner.png" alt="" />
        <div class="banner-text">
          <div>SPECIALIST COMPRESSOR<br />MANUFACTURERS</div>
        </div>
      </div>
      <div class="about">
        <div class="title">About us and our strengths</div>
        <img src="../assets/aboutPage/aboutUs.png" alt="" />
      </div>
      <div class="cont-box products">
        <div class="head">
          <div class="title">About our products</div>
          <div class="des">
            Hydrogen energy is a clean, efficient and safe new energy, which is
            regarded as one of the most promising clean energy in the 21st
            century. The characteristics of hydrogen energy include a wide range
            of sources, high calorific value of combustion, large energy
            density, storable, renewable, electrically combustible, zero carbon
            emission, etc. Hydrogen energy can be applied to automobiles, rail
            transit, ships and other fields through hydrogen fuel cell
            technology, and can also be applied to distributed power generation
            and energy storage
          </div>
        </div>
        <div class="cont">
          <div class="nav">
            <div
              class="nav-item"
              :class="{ active: selected === item.menuId }"
              v-for="item in productTagList"
              :key="item.menuId"
              @click="showInfos(item)"
            >
              {{ item.guideZw }}
            </div>
          </div>
          <div class="list">
            <div
              class="list-item"
             v-for="ite in productList" :key="ite.productId" 
              @click="showDialog(ite.productId)"
            >
              <div class="top">
                <img class="img" :src="ite.backup1" alt="" />
              </div>
              <div class="bottom">
                <div class="title">{{ ite.backup }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="foot">
        <div class="foot-banner">
          <div>SYNERGY FOR GAS s.r.l.</div>
          <div>
            Beijing PFA Power Holding Co., LTD., founded in 2010 (referred to as
            "PFA Power"), was listed in the National SME Share Transfer System
            (New Third Board) in 2016 (stock code: 836468), and entered the new
            Third Board innovation layer in May 2021. The company is located in
            Beijing Daxing District international hydrogen energy demonstration
            zone. As a high-tech enterprise, Beijing Pfeiffer was recognized as
            the first batch of "specialized and special new" enterprises in
            Beijing in 2022. In 2023, the first batch of "little Giant"
            enterprises were identified. Pfeiffer Power is a large equipment
            manufacturer mainly engaged in the development, production and sales
            of high-pressure gas compressors. From vehicle natural gas
            compressor to vehicle hydrogen compressor, from natural gas mother
            station compressor to hydrogen filling compressor, from natural gas
            pipeline booster to hydrogen energy storage booster, etc., are the
            company's product categories.
          </div>
        </div>
        <div class="foot-about">
          <div class="title">Contact Us</div>
          <div class="list">
            <div class="list-item">
              <img src="../assets/foot1.png" alt="" />
              <div class="title">Email</div>
              <div class="detail">synergyforgas@gmail.com</div>
            </div>
            <div class="list-item">
              <img src="../assets/foot2.png" alt="" />
              <div class="title">phone</div>
              <div class="detail">&nbsp;051-751873</div>
            </div>
            <div class="list-item">
              <img src="../assets/foot3.png" alt="" />
              <div class="title">Facsimile</div>
              <div class="detail">051-751873</div>
            </div>
            <div class="list-item">
              <img src="../assets/foot4.png" alt="" />
              <div class="title">address</div>
              <div class="detail">
                PISTOIA (ITALIA) in Via PIEMONTE N 34 -51039
              </div>
            </div>
          </div>
        </div>
      </div>
      <el-dialog :title="productContent.backup" :visible.sync="dialogVisible">
        <div class="ql-container ql-snow">
          <div class="ql-editor">
            <div  v-html="productContent.content"></div>
          </div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import { getGWProductInfoList, getGWProductInfoListById ,getGWProductDetailById} from "@/api/search";
export default {
  name: "forgas",
  components: {},
  data() {
    return {
      languageType: "2",
      productTagList: [],
      productList: [],
      selected: null,
      dialogVisible: false,
      productContent: {},
    };
  },
  watch: {
    $route(to, from) {},
  },
  created() {
    this.getGWProductInfoList();
  },
  methods: {
    // 产品导航菜单
    getGWProductInfoList() {
      let params = {
        language: 2,
      };
      getGWProductInfoList(params).then((res) => {
        console.log("查询全部产品导航", res.data);
        this.productTagList = res.data.obj[0].gList;
        this.selected = this.productTagList[0].menuId;
        this.getGWProductInfoListById(this.selected);
      });
    },
    showInfos(row) {
      // 点击菜单切换数据
      console.log("产品列表---", row);
      this.selected = row.menuId;
      this.getGWProductInfoListById(row.menuId);
    },
    // 产品列表
    getGWProductInfoListById(menuId) {
      let params = {
        language: 2,
        menuId: menuId,
      };
      getGWProductInfoListById(params).then((res) => {
        console.log("根据ID查询产品", res.data.obj);
        this.productList = res.data.obj;
      });
    },
    // 产品详情
    getGWProductDetailById(id) {
      let params = {
        language: 2,
        productId: id,
      };
      getGWProductDetailById(params).then((res) => {
        console.log('根据ID查询产品详情', res.data.obj);
        this.productContent = res.data.obj;
      });
    },
    showDialog(productId) {
      console.log('hhshh',productId)
      this.productContent = {}
      this.getGWProductDetailById(productId);
      this.dialogVisible = true;
    },
  },
};
</script>
<style scoped lang="less">
@deep: ~'>>>';
@{deep}.el-dialog{width:80%!important;height: 80vh;overflow-y: scroll;
.ql-editor{margin: auto;}
}
@{deep}.ql-align-center img{width:100%!important;}
.home {
  font-size: 0.225rem;
  min-height: 100vh;
  background: #001b36;
  color: #fff;
  width: 100vw;
  max-width: 100vw;
  overflow: hidden;
}

.logo {
  width: 3.725rem;
  height: 1.7rem;
  padding: 0.875rem;
}

.logo img {
  width: 100%;
}

.banner {
  position: relative;
}

.banner-text {
  font-family: YouSheBiaoTiHei;
  font-size: 0.7rem;
  font-weight: 400;
  line-height: 0.7375rem;
  text-align: center;
  letter-spacing: 0;
  font-variation-settings: "opsz" auto;
  color: #fff;
  margin-top: -9.25rem;
}

.content {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 0 7.2917vw;
  background: url(../assets/product_banner.png) 0 0 no-repeat;
  background-size: cover;
  overflow-x: hidden;
}

.content .banner {
  width: 85.4167vw;
}

.content .banner img {
  width: 100%;
  height: 100%;
}

.about {
  margin-top: 2.24479rem;
  width: 17rem;
  height: 10.125rem;
  border-radius: 0.25rem;
  background: rgba(0, 0, 0, 0.6);
  box-sizing: border-box;
  border: 0.0125rem solid #ff9d3b;
  padding: 0.5rem 0.625rem 0 0.625rem;
}

.about .title {
  font-family: Source Han Sans;
  font-size: 0.45rem;
  font-weight: 500;
  line-height: 1rem;
  text-align: center;
  color: #ff9d3b;
  margin-bottom: 0.15625rem;
}

.about img {
  width: 100%;
}

.cont-box {
  display: flex;
  flex-direction: column;
}

.cont-box .head {
  text-align: left;
  margin: 1.075rem 0 0.65rem;
}

.cont-box .head .title {
  font-size: 0.525rem;
  font-weight: 500;
  line-height: 0.725rem;
}

.cont-box .head .des {
  width: 12.5rem;
  font-family: Source Han Sans;
  font-size: 0.2rem;
  font-weight: 350;
  line-height: normal;
  letter-spacing: 0;
  font-variation-settings: "opsz" auto;
  color: #adadad;
}

.cont-box .nav {
  display: flex;
  gap: 0.225rem;
}

.cont-box .nav .nav-item {
  font-size: 0.25rem;
  line-height: 0.25rem;
  padding: 0.125rem 0.325rem;
  white-space: nowrap;
  border-radius: 0.625rem;
}

.cont-box .nav .active,
.cont-box .nav .nav-item:hover {
  color: #3d3d3d;
  background: #fff;
  cursor: pointer;
}

.cont-box .cont {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  gap: 1.125rem;
}

.cont-box .list {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 0.8125rem;
}

.cont-box .list .list-item {
  max-width: 3rem;
  border-radius: 0.05rem;
  position: relative;
}

.cont-box .list .list-item img {
  width: 100%;
  height: 100%;
}

.cont-box .list .list-item .bottom {
  width: 100%;
}

.cont-box .list-item .title {
  height: 0.625rem;
  font-weight: 500;
  font-size: 0.275rem;
  line-height: 0.35rem;
  margin-top: 0.3125rem;
  -webkit-line-clamp: 2;
}

.cont-box .list-item .des,
.cont-box .list-item .title {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: center;
}

.cont-box .list-item .des {
  font-weight: 350;
  font-size: 0.09375rem;
  line-height: 0.09375rem;
  margin-top: 0.0625rem;
  -webkit-line-clamp: 1;
}

.cont-box .list-item .top {
  position: relative;
  width: 100%;
  height: 0;
  padding-top: 100%;
}

.cont-box .list-item .top img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.products {
  width: 100%;
  margin: 0 1.35417rem;
}

.products .list .list-item {
  min-width: 0;
}

.foot {
  position: relative;
  margin-top: 2.75rem;
  background: url(../assets/foot_banner.png);
  background-size: cover;
  background-color: #00264b;
}

.foot-banner {
  position: absolute;
  top: -1.11458rem;
  left: 7.2917vw;
  width: 24rem;
  height: 8.95rem;
  background: url(../assets/about_banner.png);
  background-size: cover;
  text-align: left;
  padding: 1.25rem;
  box-sizing: border-box;
}

.foot-banner :first-child {
  font-family: YouSheBiaoTiHei;
  font-size: 0.75rem;
  line-height: 0.6rem;
  color: #fff;
  margin-bottom: 0.5rem;
}

.foot-banner :last-child {
  width: 14.875rem;
  font-family: Source Han Sans;
  font-size: 0.25rem;
  font-weight: 350;
  line-height: normal;
  color: #fff;
}

.foot-about {
  width: 24rem;
}

.foot-about > .title {
  position: relative;
  font-family: YouSheBiaoTiHei;
  font-size: 0.6937rem;
  font-weight: 400;
  line-height: 0.375rem;
  text-align: center;
  letter-spacing: 0;
  font-variation-settings: "opsz" auto;
  color: #fff;
  margin-top: 9.5625rem;
}

.foot-about > .title:before {
  left: 3.39063rem;
}

.foot-about > .title:after,
.foot-about > .title:before {
  position: absolute;
  top: 0.15625rem;
  content: "";
  display: block;
  width: 5.625rem;
  border-top: 0.00521rem solid #fff;
}

.foot-about > .title:after {
  right: 3.39063rem;
}

.foot-about .list {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 0.44271rem;
  padding: 2.5rem 7.2917vw;
  margin-bottom: 0.52083rem;
}

.foot-about .list-item {
  background: #005db9;
  width: 3.75rem;
  height: 3.75rem;
  padding: 0.6rem 0.2rem;
  box-sizing: border-box;
}

.foot-about .list-item img {
  width: 1rem;
  height: 1rem;
}

.foot-about .list-item .title {
  margin-top: 0.125rem;
}

.foot-about .list-item .detail,
.foot-about .list-item .title {
  font-family: Source Han Sans;
  font-size: 0.25rem;
  font-weight: 500;
  line-height: normal;
  text-align: center;
  color: #fff;
}

.foot-about .list-item .detail {
  margin-top: 0.35rem;
}
img {
  width: 100%;
}
</style>